<script>
  import { wsx } from "@axel669/zephyr";
  import { Screen, Paper, Flex, Titlebar, Text, LoadZone } from "@axel669/zephyr";

  const commitInfo = process.env.UI_RELEASE_COMMIT;

  let versionInfo = {};
  const getServerInfo = async () => {
    const res = await fetch('/api/version');
    versionInfo = await res.json();
    return versionInfo;
  }

</script>

<svelte:body use:wsx={{ "@@theme": 'dark', "@@app": true, "p": "8px" }} />

<Screen>
  <Paper>
    <Titlebar slot="header">
      <Flex p="0px" gap="0px" slot="title">
        <Text title> Asset Test </Text>
      </Flex>
    </Titlebar>

    <LoadZone source={getServerInfo()} let:result>
      <Flex>
        <pre>
          Client Commit: {commitInfo.commit}
          Server Commit: {result.commit}
          Current User : {result.username}
        </pre>
      </Flex>
    </LoadZone>

    <Titlebar slot="footer">
      <Text slot="title" title>
        <Text subtitle>Build: {process.env.BUILD_ENV}</Text>
      </Text>
    </Titlebar>
  </Paper>
</Screen>